import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTimeSlotAction } from "../../../redux/actions/InfrastructureDetailsAction";
import {
  getInfrastructureDetailPopupAction,
  getProviderProfileDetailAction,
} from "../../../redux/actions/ProviderProfileDetailAction";
import { getNetworkMenuId } from "../../../Utils/types";
import { ApproveRejectButton, initialFilterState } from "./helper";

export const InfrastructurePopup = ({
  rowData,
  searchFilter,
  apiParams,
  setRowData,
}) => {
  const dispatch = useDispatch();
  const [remark, setRemark] = useState("");
  const getViewDetailPage = useSelector(
    (state) =>
      state?.providerPortalDetailReducer?.getViewDetailPage
        ?.infrastructureDetails
  );
  const getTimeSlot = useSelector(
    (state) => state?.InfrastructureDetailsReducer?.getTimeSlot
  );

  useEffect(() => {
    dispatch(
      getInfrastructureDetailPopupAction(rowData?.requestID, rowData?.sessionID)
    );
    dispatch(getTimeSlotAction("", ""));
  }, []);

  const getTimeSlots = (slotDayData) => {
    const arr = slotDayData?.split(",")?.map((ele) => +ele);
    const res = getTimeSlot?.filter(({ timeSlotId }) =>
      arr?.includes(+timeSlotId)
    );
    return res;
  };

  const centerInfrastructureHighlights = [
    {
      heading: "CCTV",
      value: "hasCCTV",
    },
    {
      heading: "Air Conditioning",
      value: "hasAirConditioning",
    },
    {
      heading: "Parking",
      value: "hasParking",
    },
    {
      heading: "Pantry",
      value: "hasPantry",
    },
    {
      heading: "Reception",
      value: "hasReception",
    },
    {
      heading: "Wheelchair Friendly",
      value: "isWheelChairFriendly",
    },
    {
      heading: "Lift",
      value: "hasLift",
    },
    {
      heading: "Lab",
      value: "hasLab",
    },
    {
      heading: "Waiting Area",
      value: "hasWaitingRoom",
    },
    {
      heading: "Washroom (Indian)",
      value: "hasIndianWashRoom",
    },
    {
      heading: "Washroom (Western)",
      value: "hasWesternWashRoom",
    },
    {
      heading: "Serve Breakfast/Food",
      value: "isFoodServed",
    },
    {
      heading: "Computerised Reporting",
      value: "isReportingComputerised",
    },
    {
      heading: "Geo Tagging (GPS Camera)",
      value: "isGeoTagging",
    },
    {
      heading: "Weight Machine",
      value: "isWeighingMachineAvailable",
    },
    {
      heading: "Height Machine",
      value: "isHeightMachineAvailable",
    },
  ];

  const weekSlotArray = [
    {
      heading: "Monday",
      value: "mondayTimeSlots",
    },
    {
      heading: "Tuesday",
      value: "tuesdayTimeSlots",
    },
    {
      heading: "Wednesday",
      value: "wednesdayTimeSlots",
    },
    {
      heading: "Thursday",
      value: "thursdayTimeSlots",
    },
    {
      heading: "Friday",
      value: "fridayTimeSlots",
    },
    {
      heading: "Saturday",
      value: "saturdayTimeSlots",
    },
    {
      heading: "Sunday",
      value: "sundayTimeSlots",
    },
  ];

  const multipleViewImages = [
    { heading: "Banner", value: "banner" },
    { heading: "Reception", value: "reception" },
    { heading: "Waiting Area", value: "waitingArea" },
    { heading: "Lab", value: "lab" },
    { heading: "Washroom (Indian/Western)", value: "washroom" },
    { heading: "Medical Equipment", value: "medicalEquipment" },
  ];
  return (
    <>
      <div className="___parent_container d-flex justify-content-between border-bottom modalHeader">
        <div className="d-flex align-items-center gap-10">
          <div className="logo-circle">
            <img src={rowData?.providerLogo} alt="" />
          </div>
          <div className="brand-name">
            <h5 className="mb-0 text-highlight font-bold">
              {rowData?.providerName}
            </h5>
          </div>
        </div>
        <div className="align-items-center gap-3 d-flex">
          {getViewDetailPage?.source && <h5 className="mb-0 text-highlight font-bold">
            <span style={{color:"black"}}>Action : </span>{getViewDetailPage?.source}
          </h5>}
          <button
          type="button"
          className="btn-close normal-close"
          onClick={async () => {
            await setRemark("");
            await setRowData(null);
            if (getViewDetailPage === undefined) {
              await dispatch(
                getProviderProfileDetailAction(initialFilterState)
              );
            }
          }}
        ></button>
          </div>
     
      </div>
      <div className="___parent_container modal-body">
        <h4
          className="font-bold text-highlight mb-4"
          style={{ letterSpacing: "1px" }}
        >
          Infrastructure Details
        </h4>
        <div className="d-flex justify-content-between gap-20 d__block pv-body">
          <div className="_left-side width_50 padding-30">
            <div className="cards bottom-spacing-30">
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">Total Area Of Facility (Sq. Ft)</div>
                <div className="font-medium pill-highlighted">
                  {getViewDetailPage?.areaOfFacility}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">
                  Total Waiting Area Of Facility (Sq. Ft)
                </div>
                <div className="font-medium pill-highlighted">
                  {getViewDetailPage?.areaOfWaitingRoom}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">
                  Client Handling Capacity (Per Day)
                </div>
                <div className="font-medium pill-highlighted">
                  {getViewDetailPage?.clientHandlingCapacityPerDay}
                </div>
              </div>
              <div className="bottom-spacing-10 d-flex justify-content-between">
                <div className="font-bold">
                  Client Handling Capacity (Per Hour)
                </div>
                <div className="font-medium pill-highlighted">
                  {getViewDetailPage?.clientHandlingCapacityPerHour}
                </div>
              </div>
            </div>
            <div className="cards bottom-spacing-30">
              <h5 className="font-bold text-black bottom-spacing-20">
                Centre Infrastructure
              </h5>
              <div className="bottom-spacing-10 d-flex gap-10 flex-wrap">
                {centerInfrastructureHighlights?.map((ele, index) => {
                  return (
                    <div
                      key={index}
                      className={`font-medium ${
                        getViewDetailPage?.[ele?.value]
                          ? "pill-highlighted"
                          : "pill-un-highlighted"
                      }`}
                    >
                      {ele?.heading}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="align-items-center mt-4">
              <h5 className="font-bold text-black bottom-spacing-20 mt-4">
                Selected Working Hours
              </h5>
              <div className="d-flex align-items-center gap-10">
                <p className="font-bold">From</p>
                <div className="font-medium pill-highlighted">
                  {getViewDetailPage?.regularTimingFrom}
                </div>
                <p className="font-bold">To</p>
                <div className="font-medium pill-highlighted">
                  {getViewDetailPage?.regularTimingTo}
                </div>
              </div>
            </div>
            <div className="cards bottom-spacing-30 mt-4">
              <h5 className="font-bold text-black bottom-spacing-20">
                Selected Working Days
              </h5>
              <div>
                {weekSlotArray?.map((ele, index) => {
                  return (
                    getViewDetailPage?.[ele?.value] !== "" && (
                      <div>
                        <div className="font-bold mb-2 mt-2">
                          {ele?.heading}
                        </div>
                        <div className="d-flex flex-wrap gap-10">
                          {getTimeSlots(getViewDetailPage?.[ele?.value])?.map(
                            (ele) => {
                              return (
                                <div className="font-medium pill-highlighted">
                                  {ele?.startTime} - {ele?.endTime}
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    )
                  );
                })}
              </div>
            </div>
          </div>
          <div className="_right-side width_50 __mt-30">
            <div className="shadow-heights pos-rel height-100">
              <div className="cards bottom-spacing-30">
                <h5 className="font-bold text-black bottom-spacing-20">
                  Uploaded Facility Images
                </h5>
                <div className="row">
                  <div className="font-bold col-md-6">
                    Logo
                    <span className="text-dark font-medium">
                      ({getViewDetailPage?.logo !== null ? 1 : 0}/1)
                    </span>
                  </div>
                  <div
                    style={{ display: "flex" }}
                    className="col-md-6 justify-content-end"
                  >
                    <a
                      href={getViewDetailPage?.logo?.imageUrl}
                      target="blank"
                      className="text-decoration"
                    >
                      {getViewDetailPage?.logo !== null ? (
                        "logo"
                      ) : (
                        <p className="text-unhighlighted">Not Uploaded</p>
                      )}
                    </a>
                  </div>
                </div>
                {multipleViewImages?.map((element, index) => {
                  return (
                    <div className="row" key={index}>
                      <div className="font-bold col-md-6 col-sm-6 col-6">
                        {element?.heading}
                        <span className="text-dark font-medium">
                          ({getViewDetailPage?.[element?.value]?.length}/5)
                        </span>
                      </div>
                      <div
                        style={{ display: "flex" }}
                        className="flex-wrap justify-content-end col-md-6 col-sm-6 col-6"
                      >
                        {!getViewDetailPage?.[element?.value]?.length && (
                          <p className="text-unhighlighted">Not Uploaded</p>
                        )}
                        {getViewDetailPage?.[element?.value]?.map(
                          (ele, index) => {
                            return (
                              <a
                                href={ele?.imageUrl}
                                target="blank"
                                className="text-decoration"
                                style={{ flex: "none", paddingLeft: "10px" }}
                              >
                                {element?.value}-{index + 1}
                              </a>
                            );
                          }
                        )}
                      </div>
                    </div>
                  );
                })}
                <div className="spacing-hr mt-0"></div>
                <div className="remarks mb-4">
                  <h5 className="font-bold text-black bottom-spacing-20 mb-3">
                    Remarks
                  </h5>
                  <textarea
                    className="textarea font-medium"
                    placeholder="Type Something Here..."
                    onChange={(e) => setRemark(e.target.value)}
                    value={
                      rowData?.requestStatus !== "Pending for Approval"
                        ? rowData?.remarks
                        : remark
                    }
                    disabled={
                      rowData?.requestStatus !== "Pending for Approval" ||
                      !getNetworkMenuId()?.canEdit
                    }
                  ></textarea>
                </div>
              </div>
              <div className="accept-reject-btns bottom-0">
                {rowData?.requestStatus === "Pending for Approval" &&
                  getNetworkMenuId()?.canEdit && (
                    <ApproveRejectButton
                      rowData={rowData}
                      setRowData={setRowData}
                      remark={remark}
                      setRemark={setRemark}
                      searchFilter={searchFilter}
                      apiParams={apiParams}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
